import React from "react";
import API from "../../base/API";
import { translate } from "../../base/Translation";
import PDFButton from "./PDFButton";

export default class PDFButtonPlain extends PDFButton {
    constructor(props) {
        super(props);

        this.api = new API({
            get_summary_report: "/test/pdf/report/:test?unfilled=1",
            get_protocol_report: "/test/pdf/protocol/:test?unfilled=1",
            get_form_report: "/test/pdf/form/:test?unfilled=1",
        });
    }

    render() {
        const buttonClass = "btn btn-primary btn-sm pull-right";

        return (
            <button className={buttonClass} style={{marginRight: "1rem"}} onClick={this.onGenerate.bind(this)}>
                <i className="fa fa-file" />&nbsp; {translate("Generovať nevyplnené PDF")}
            </button>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/parts/PDFButtonPlain.jsx